var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentMaestroicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 24,
    viewBox: "0 0 35 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 34,
    height: 23,
    rx: 3.5,
    fill: "white",
    stroke: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2715 5.22363C17.0399 5.22388 20.0947 8.31469 20.0947 12.127C20.0945 15.9391 17.0398 19.0291 13.2715 19.0293C9.50293 19.0293 6.44744 15.9392 6.44727 12.127C6.44727 8.31454 9.50282 5.22363 13.2715 5.22363Z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.123 5.22363C25.8915 5.22388 28.9463 8.31469 28.9463 12.127C28.9461 15.9391 25.8914 19.0291 22.123 19.0293C18.3545 19.0293 15.299 15.9392 15.2988 12.127C15.2988 8.31454 18.3544 5.22363 22.123 5.22363Z",
    fill: "#0099DF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6963 6.875C19.1629 8.14112 20.0937 10.0236 20.0938 12.127C20.0938 14.2301 19.1626 16.1118 17.6963 17.3779C16.23 16.1118 15.2988 14.23 15.2988 12.127C15.2988 10.0236 16.2297 8.14112 17.6963 6.875Z",
    fill: "#6C6BBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentMaestroicon);
export default __webpack_public_path__ + "static/media/payment-maestro.icon.42aaf515fcdd9c168e4274bc6ff5222d.svg";
export { ForwardRef as ReactComponent };